<template>
  <div>
    <Alert
      v-if="deletedItems.deletedItemIds.length > 0"
      :delay="delay"
      type="success"
      @hidden="handleDeleteAlertHidden('deletedItemIds')"
    >
      <span>
        {{ successMessage }}
      </span>
    </Alert>
    <Alert
      v-if="deletedItems.failedTasks.length > 0"
      :delay="delay"
      type="error"
      @hidden="handleDeleteAlertHidden('failedTasks')"
    >
      <span>
        {{ errorMessage }}
      </span>
    </Alert>
  </div>
</template>

<script>
import { ItemTypeDisplayNames, StoreModuleMap } from 'client/util/Constants';
import { extend } from 'lodash';
import { mapActions, mapState } from 'vuex';
import Alert from 'client/components/Alert/Alert.vue';
import pluralize from 'pluralize';

export default {
  name: 'DeleteItemsNotifications',

  components: {
    Alert,
  },

  props: {
    delay: {
      type: Number,
      default: 7000,
    },
    displayName: {
      type: String,
      default: '',
    },
    itemType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    errorMessage() {
      return `${pluralize(this.noun, this.deletedItems.failedTasks.length, true)} ${pluralize('was', this.deletedItems.failedTasks.length)} unable to be removed from JumpCloud.`;
    },

    noun() {
      return this.displayName || String(ItemTypeDisplayNames[this.itemType]).toLowerCase();
    },

    successMessage() {
      return `${pluralize(this.noun, this.deletedItems.deletedItemIds.length, true)} ${pluralize('was', this.deletedItems.deletedItemIds.length)} removed from JumpCloud.`;
    },
  },

  beforeCreate() {
    const { itemType } = this.$options.propsData;
    const storeModule = StoreModuleMap[itemType];

    extend(
      this.$options.methods,
      mapActions(storeModule, ['resetDeletedItemIds']),
    );

    extend(
      this.$options.computed,
      mapState(storeModule, { deletedItems: state => state.features.deletedItems }),
    );
  },

  methods: {
    handleDeleteAlertHidden(key) {
      this.resetDeletedItemIds(key);
    },
  },
};
</script>
